import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    backgroundColor: theme.palette.custom.background.area,
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[25],
    transition: '.3s ease',
    overflow: 'auto',

    '&:hover': {
      boxShadow: theme.shadows[6],
      transition: '.3s ease',
    },

    '& > .section-title': {
      minHeight: theme.spacing(7),
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing(0, 3),
      fontWeight: theme.typography.fontWeightMedium,
      color: theme.palette.text.hint,
    },
  },
}));

export default styles;
